export default __webpack_public_path__ + "static/media/wayfinding_tile.1efa7e7f.png";